function onJQueryLoad(callback) {
  if (window.jQuery) {
    callback();
  } else {
    setTimeout(function() {
      onJQueryLoad(callback);
    }, 50);
  }
}

onJQueryLoad(function() {
  $(document).ready(function() {
    const slider = new CareOfProductsSlider($('.care-of-products-slider'));
    slider.init();
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.video-player').forEach(videoEl => {
    new VideoPlayer(videoEl);
  });
});